import React, { useContext } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";

function Footer() {
  const { config } = useSiteConfig();
  const { categories } = useContext(CategoryContext);

  return (
    <footer id="footer" className="custom-footer">
      <Container className="px-md-5 px-3">
        <Row className="g-4">
          {/* Column 1: Brand/About */}
          <Col lg={3} md={6}>
            <Link to="/" className="d-block mb-3">
              <img src={config?.logo} alt="logo" className="footer-logo-img" />
            </Link>
            <p className="footer-text">
  Fueling Your Hustle with Premium Dryfruits. 
  Crunchy, Healthy, <br/> and Full of Vibe.
</p>
            <div className="d-flex gap-2 mt-4">
              {config?.socialMedia?.facebook && (
                <a href={config.socialMedia.facebook} target="_blank" rel="noreferrer" className="social-icon-link">
                  <FaFacebookF size={16} />
                </a>
              )}
              {config?.socialMedia?.instagram && (
                <a href={config.socialMedia.instagram} target="_blank" rel="noreferrer" className="social-icon-link">
                  <FaInstagram size={16} />
                </a>
              )}
              {config?.socialMedia?.twitter && (
                <a href={config.socialMedia.twitter} target="_blank" rel="noreferrer" className="social-icon-link">
                  <FaTwitter size={16} />
                </a>
              )}
              {config?.socialMedia?.youtube && (
                <a href={config.socialMedia.youtube} target="_blank" rel="noreferrer" className="social-icon-link">
                  <FaYoutube size={16} />
                </a>
              )}
            </div>
          </Col>

          {/* Column 2: Legal */}
          <Col lg={2} md={6} xs={6}>
            <h5 className="footer-heading">Support</h5>
            <ul className="footer-links">
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/return-and-refund-policy">Refund Policy</Link></li>
            </ul>
          </Col>

          {/* Column 3: Quick Links */}
          <Col lg={2} md={6} xs={6}>
            <h5 className="footer-heading">Company</h5>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/shop">Shop</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </Col>

          {/* Column 4: Categories */}
          <Col lg={2} md={6} xs={6}>
            <h5 className="footer-heading">Categories</h5>
            <ul className="footer-links">
              {categories?.slice(0, 5).map((cat) => (
                <li key={cat._id}>
                  <Link to={`/categories/${cat.slugPath}`}>{cat.name}</Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Column 5: Newsletter/Contact */}
          <Col lg={3} md={6} xs={12}>
            <h5 className="footer-heading">Get In Touch</h5>
            <p className="footer-text mb-2">Email: {config?.email}</p>
            <p className="footer-text">Stay updated with our latest drops and exclusive offers.</p>
          </Col>
        </Row>

        {/* Bottom Bar */}
        <div className="footer-bottom mt-5 pt-4">
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start mb-3 mb-md-0">
              <p className="mb-0 footer-text">
                All Rights Reserved © 2026 <strong>Snackiya</strong>
              </p>
            </Col>
            <Col md={6} className="text-center text-md-end">
              <a
                href="https://axesell.com"
                className="floating-designer-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/images/axesell_logo.png" className="floating-icon" alt="Axesell" />
              </a>
            </Col>
          </Row>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;